import { render } from "./metfone-loading.vue?vue&type=template&id=8a1e6ad6&scoped=true"
import script from "./metfone-loading.vue?vue&type=script&lang=js"
export * from "./metfone-loading.vue?vue&type=script&lang=js"

import "./metfone-loading.vue?vue&type=style&index=0&id=8a1e6ad6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1e6ad6"]])

export default __exports__